webpackJsonp([5],{

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//

exports.default = {
  name: 'App',
  data: function data() {
    return {
      skinData: '',
      isRouterAlive: true
    };
  },
  created: function created() {
    // this.getSkinType();
  },

  methods: {
    // 获取主题类型
    getSkinType: function getSkinType() {
      var vm = this;
      var params = {
        callback: function callback(code, opt) {
          opt = (typeof opt === 'undefined' ? 'undefined' : _typeof(opt)) === 'object' ? opt : JSON.parse(opt);
          vm.skinData = Number(opt.ret) === 1 ? 'night' : '';
          sessionStorage.setItem('skinData', vm.skinData);
          vm.isRouterAlive = true;
        }
      };
      upNativeComm.exec('WebView.getThemeType', params);
    }
  }
};

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(135);
module.exports = __webpack_require__(337);


/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(338);

var _jquery = __webpack_require__(133);

var _jquery2 = _interopRequireDefault(_jquery);

var _home = __webpack_require__(340);

var _home2 = _interopRequireDefault(_home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import stylesheets
window.$ = _jquery2.default;
window.jQuery = _jquery2.default;

(0, _jquery2.default)(document).ready(function () {
  var page = (0, _jquery2.default)("body").children().first().attr("data-page");
  if (!page) {
    return false;
  }
  switch (page) {
    case "home":
      new _home2.default();
      break;
    default:
      throw new Error("No page found.");
  }
});

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = home;

var _vue = __webpack_require__(130);

var _vue2 = _interopRequireDefault(_vue);

var _vueScroller = __webpack_require__(344);

var _vueScroller2 = _interopRequireDefault(_vueScroller);

var _App = __webpack_require__(345);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(347);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueScroller2.default);

function home() {
  new _vue2.default({
    el: "#app",
    router: _router2.default,
    template: "<App/>",
    components: {
      App: _App2.default
    }
  });
}

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_presets_env_targets_browsers_1_last_4_versions_Firefox_ESR_not_ie_9_iOS_8_Android_4_stage_2_react_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_presets_env_targets_browsers_1_last_4_versions_Firefox_ESR_not_ie_9_iOS_8_Android_4_stage_2_react_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_presets_env_targets_browsers_1_last_4_versions_Firefox_ESR_not_ie_9_iOS_8_Android_4_stage_2_react_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_presets_env_targets_browsers_1_last_4_versions_Firefox_ESR_not_ie_9_iOS_8_Android_4_stage_2_react_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_presets_env_targets_browsers_1_last_4_versions_Firefox_ESR_not_ie_9_iOS_8_Android_4_stage_2_react_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c01b644c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(346);
var normalizeComponent = __webpack_require__(132)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_presets_env_targets_browsers_1_last_4_versions_Firefox_ESR_not_ie_9_iOS_8_Android_4_stage_2_react_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c01b644c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constantRouterMap = undefined;

var _vue = __webpack_require__(130);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(348);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _nprogress = __webpack_require__(349);

var _nprogress2 = _interopRequireDefault(_nprogress);

__webpack_require__(350);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Progress 进度条样式

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

_vue2.default.use(_vueRouter2.default);

var constantRouterMap = exports.constantRouterMap = [{ path: __publicPath + '/', component: function component() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 352));
  } }, { path: __publicPath + '/ListforApp', component: function component() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 353));
  } }, { path: __publicPath + '/settings', component: function component() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 354));
  } }, { path: '*', component: function component() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 355));
  } }];

var router = new _vueRouter2.default({
  // mode: 'history', //后端支持可开
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  mode: 'history',
  routes: constantRouterMap
});

// NProgress.configure({ showSpinner: false });

router.beforeEach(function (to, from, next) {
  // NProgress.start();
  next();
});

router.afterEach(function () {
  // NProgress.done();
});

exports.default = router;

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[134]);


// WEBPACK FOOTER //
// js/main.0c52d9910ccb9f8c814b.js